import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'tenant-info-mode',
  templateUrl: './edit-tenant-info.component.html',
  styleUrls: ['./edit-tenant-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditTenantInfoComponent implements OnInit {

  @Input('tenant') tenant!:TenantDto;
  editTenantForm!:FormGroup;
  systemType!:string;

  constructor(private fb: FormBuilder, 
    private route: ActivatedRoute,
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    console.log("----------------> tenant-info-mode tenant: ", this.tenant)
    this.tenantService.currentTenantName = this.tenant.name;
    this.tenantService.currentTenantId = this.tenant.id;
    this.systemType = this.tenant.systemType;
    this.buildTenantForm(this.tenant);
  }

  buildTenantForm(tenant: TenantDto) {
    this.editTenantForm = this.fb.group({
      id:[tenant.id],
      name:[tenant.displayName],
      scopeName: [tenant.scopeName],
      frontendUrl: [tenant.frontendUrl],
      systemType: [tenant.systemType],
      wpApiKeyInbound: [tenant.wpApiKeyInbound],
      wpServerUrl: [tenant.wpServerUrl],
      wpApiUser: [tenant.wpApiUser],
      wpApiKey: [tenant.wpApiKey],
      wpTenantName: [tenant.wpTenantName],
      serverName:""
    })
  }

  editTenant(){
    if(this.editTenantForm.valid){
      let tenant = new TenantDto;
      tenant.name = this.editTenantForm.value.name;

      this.notificationService.warning(``,`nicht implmentiert! (edit-tenant-info)`)
      this.tenantService.updateTenancy(tenant).subscribe({
        next:() => {}
      });
    }
  }

}
